import { Button, Form, ListGroup, Modal, Spinner } from "react-bootstrap";
import { DEV_SERVER } from "../../../constants/urls";
import axios from "axios";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { userSignal } from "../../../signal/userSignal";
import MapModal from "../maps/MapModal";
import Select from 'react-select';
import { allUsersSignal } from "../../../signal/allUsersSignal";
import { myGrpsSignal } from "../../../signal/myGrpsSIgnals";


export default function AddFarmerModal(props) {

    const [Farmer, setFarmers] = useState(props?.Farmer ? props?.Farmer : {
        name: "",
        phoneNumber: "",
        email: "",
        gstin: "",
        address: "",
        city: "",
        state: "",
        group: "",
        pincode: "",
        website: "",
        aboutParty: "",
        visitingCard: [],
        userId: "",
        managerId: "",
        location: [0.0, 0.0]
    })
    const [showMap, setShowMap] = useState(false)
    const [placeSearchTimeout, setPlaceSearchTimeout] = useState(null);
    const [suggestions, setSuggestions] = useState([]); // [{}
    const [loading, setLoading] = useState(false);
    const [edit, setEdit] = useState(false);

    useEffect(() => {
        if (props?.Farmer) {
            setEdit(true)
            setFarmers(props?.Farmer)
        }
    }, [props])

    const imageUploadMutation = useMutation((data) => axios.post(`${DEV_SERVER}/auth/v2/uploadMedia`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": `Bearer ${userSignal.value?.token}`
        }
    }), {
        onSuccess: (data) => {
            if (data?.data?.status) {
                if (data?.data?.data?.length > 0) {
                    let visitingCards = Farmer.visitingCard || [];
                    data.data.data.map((item) => {
                        visitingCards.push(item)
                    })
                    setFarmers({ ...Farmer, visitingCard: visitingCards })
                } else {
                    toast.error("Something went wrong")
                }
            } else {
                toast.error(data.data.message)
            }
        },
        onError: (error) => {
            console.log("error ", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error(error.message)
            }
        }
    })

    const handleImageUpload = (e) => {
        let data = new FormData();
        for (let i = 0; i < e.target.files?.length; i++) {
            data.append("media", e.target.files[i])
        }
        imageUploadMutation.mutate(data)
    }

    const handleLocationSelecion = (selectedCoordinates, address) => {
        setFarmers({
            ...Farmer,
            location: [selectedCoordinates.lat, selectedCoordinates.lng],
            address: address.area,
            city: address.city,
            state: address.state,
            pincode: address.pincode
        })
    }

    const addFarmerMutation = useMutation((body) => axios.post(`${DEV_SERVER}/farmer/v2`, body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },

    }), {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                props?.close();
                props?.refetchFarmers();
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const handleAddFarmer = () => {
        if (Farmer.name === "") {
            toast.error("Name is required");
            return;
        }

        if (Farmer.phoneNumber === "" || Farmer.phoneNumber.toString()?.length !== 10) {
            toast.error("Phone Number is required");
            return;
        }

        if (Farmer.address === "") {
            toast.error("Address is required");
            return;
        }

        let body = { ...Farmer }
        if (body.pincode === "" || body.pincode === NaN) {
            delete body.pincode
        } else {
            body.pincode = parseInt(body.pincode)
        }
        body.phoneNumber = parseInt(body.phoneNumber)
        addFarmerMutation.mutate(body);
    }

    const editDelaerMutation = useMutation((body) => axios.put(`${DEV_SERVER}/farmer/v2/${body.id}`, body.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                props?.close();
                props?.refetchFarmers();
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const handleEditFarmer = () => {
        if (Farmer.name === "") {
            toast.error("Name is required");
            return;
        }

        if (Farmer.phoneNumber === "" || Farmer.phoneNumber.toString().length !== 10) {
            toast.error("Phone Number is required");
            return;
        }

        if (Farmer.address === "") {
            toast.error("Address is required");
            return;
        }

        let body = { ...Farmer }
        delete body.id
        if (body.pincode === "" || body.pincode === NaN) {
            delete body.pincode
        } else {
            body.pincode = parseInt(body.pincode)
        }
        body.phoneNumber = parseInt(body.phoneNumber)
        editDelaerMutation.mutate({
            body: body,
            id: Farmer.id
        });
    }

    // const handlePlaceSearch = (e) => {

    //     setFarmers({ ...Farmer, address: e.target.value })

    //     if (placeSearchTimeout === null && e.target.value.length > 3) {
    //         setLoading(true)
    //         setPlaceSearchTimeout(setTimeout(() => {
    //             clearTimeout(placeSearchTimeout)
    //             setPlaceSearchTimeout(null)
    //             searchPlace(e.target.value)
    //         }, 1000))
    //     }
    // }

    // const searchPlace = async (query) => {
    //     let resp = await axios.get(`https://nominatim.openstreetmap.org/search?q=${query}&format=json&polygon_kml=1&addressdetails=1&limit=5&extratags=0&namedetails=0&countrycodes=in&featureType=country,state,city&dedupe=1`)

    //     setLoading(false)
    //     if (resp.status === 200) {
    //         setSuggestions(resp.data)
    //     }
    // }

    return (
        <Modal fullscreen show={props?.show} onHide={() => props?.close()}>
            <Modal.Header closeButton>
                <Modal.Title>Add Farmer</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <Form className="d-flex flex-wrap justify-content-center align-items-center" style={{ rowGap: "1rem", columnGap: "1rem", gridTemplateColumns: "0.5fr 0.5fr" }}>
                    {/* <div></div> */}
                    <Form.Group className="mb-3 col-4 align-self-center" controlId="formBasicName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control required={true} value={Farmer.name} onChange={(e) => setFarmers({ ...Farmer, name: e.target.value })} type="text" placeholder="Enter name" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicPhoneNumber">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control required={true} value={Farmer.phoneNumber} onChange={(e) => {
                            if (e.target?.value?.toString()?.length <= 10) {
                                setFarmers({ ...Farmer, phoneNumber: e.target.value })
                            }
                        }} type="number" placeholder="Enter phone number" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control value={Farmer.email} onChange={(e) => setFarmers({ ...Farmer, email: e.target.value })} type="email" placeholder="Enter email" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicGSTIN">
                        <Form.Label>GSTIN</Form.Label>
                        <Form.Control value={Farmer.gstin} onChange={(e) => setFarmers({ ...Farmer, gstin: e.target.value })} type="text" placeholder="Enter GSTIN" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicUser">
                        <Form.Label>Group</Form.Label>
                        <Select as="select"
                            options={myGrpsSignal.value?.map((grp) => ({ value: grp, label: grp }))}
                            value={{ value: Farmer?.group, label: Farmer?.group }}
                            onChange={(e) => setFarmers({ ...Farmer, group: e?.value })}
                            isSearchable
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicUser">
                        <Form.Label>Assigned Employee</Form.Label>
                        <Select as="select"
                            value={{ label: allUsersSignal.value[Farmer?.userId]?.name, value: Farmer?.userId }}
                            onChange={(e) => {

                                let temp = {...Farmer}
                                temp.userId = e?.value
                                if(Farmer?.managerId === "" || Farmer?.managerId === null || Farmer?.managerId === undefined || Farmer?.managerId === "000000000000000000000000"){
                                    if(allUsersSignal.value[e?.value]?.managerId !== "" && allUsersSignal.value[e?.value]?.managerId !== null && allUsersSignal.value[e?.value]?.managerId !== undefined && allUsersSignal.value[e?.value]?.managerId !== "000000000000000000000000"){
                                        temp.managerId = allUsersSignal.value[e?.value]?.managerId
                                    }                                  
                                }
                                setFarmers(temp)
                            }}
                            options={Object.entries(allUsersSignal.value).map(([key, value]) => {
                                return (
                                    {
                                        label: value?.name,
                                        value: key.toString()
                                    }
                                )
                            })
                            }
                            isSearchable
                            isClearable
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicAddress">
                        <Form.Label>Address</Form.Label>
                        <div className="d-flex align-items-center" style={{ columnGap: "1rem" }}>
                            <Form.Control value={Farmer.address} onChange={(e) => setFarmers({ ...Farmer, address: e.target.value })} type="search" placeholder="Enter address" />
                            <i className="fa fa-map" style={{ cursor: "pointer", color: '#096DD9' }} onClick={() => {
                                setShowMap(true)
                            }} />
                        </div>
                    </Form.Group>



                    <Form.Group className="mb-3 col-4" controlId="formBasicCity">
                        <Form.Label>City</Form.Label>
                        <Form.Control value={Farmer.city} onChange={(e) => setFarmers({ ...Farmer, city: e.target.value })} type="text" placeholder="Enter city" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicState">
                        <Form.Label>State</Form.Label>
                        <Form.Control value={Farmer.state} onChange={(e) => setFarmers({ ...Farmer, state: e.target.value })} type="text" placeholder="Enter state" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicPincode">
                        <Form.Label>Pincode</Form.Label>
                        <Form.Control value={Farmer.pincode} onChange={(e) => setFarmers({ ...Farmer, pincode: e.target.value })} type="text" placeholder="Enter pincode" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4 align-self-start" controlId="formBasicWebsite">
                        <Form.Label>Website</Form.Label>
                        <Form.Control value={Farmer.website} onChange={(e) => setFarmers({ ...Farmer, website: e.target.value })} type="text" placeholder="Enter website" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4 align-self-start" controlId="formBasicAboutParty">
                        <Form.Label>About Party</Form.Label>
                        <Form.Control value={Farmer.aboutParty} onChange={(e) => setFarmers({ ...Farmer, aboutParty: e.target.value })} rows={5} cols={5} as="textarea" placeholder="Enter about party" />
                    </Form.Group>

                    <Form.Group className="mb-3 col-4" controlId="formBasicImages">
                        <Form.Label>Visiting Cards</Form.Label>
                        <div className="d-flex justify-content-center align-items-center flex-wrap" style={{ columnGap: "0.5rem" }}>
                            {(Farmer?.visitingCard?.length && Farmer?.visitingCard?.length !== 0) && Farmer.visitingCard.map((item, i) => {
                                return <div key={i} className="mt-3" style={{ width: "50px", height: "50px", margin: "0.5rem", position: "relative" }}>
                                    <img
                                        style={{ height: "100%", width: "100%" }}
                                        className="d-block w-100"
                                        src={item.url}
                                        alt="First slide"
                                    />
                                    <span onClick={() => {
                                        let images = Farmer.visitingCard;
                                        images.splice(i, 1);
                                        setFarmers({ ...Farmer, visitingCard: images })
                                    }} className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                        <i style={{ cursor: "pointer" }} className="fas fa-times"></i>
                                        <span className="visually-hidden">unread messages</span>
                                    </span>
                                </div>
                            })}
                            <button disabled={imageUploadMutation.isLoading} className="btn btn-primary mt-3 d-flex justify-content-center align-items-center" style={{ width: "50px", height: "50px", margin: "0.5rem", position: "relative" }}>
                                <i className="fas fa-upload"></i>
                                <input onClick={(e) => { e.target.value = null }} onChange={(e) => handleImageUpload(e)} type="file" multiple style={{ width: "50px", height: "50px", position: "absolute", top: "0", left: "0", opacity: "0", cursor: "pointer" }} />
                            </button>
                        </div>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                {edit ? <Button disabled={editDelaerMutation.isLoading || imageUploadMutation.isLoading} variant="primary" onClick={() => handleEditFarmer()}>
                    {(editDelaerMutation.isLoading || imageUploadMutation.isLoading) ? <Spinner animation="border" size="sm" /> : "Edit"}</Button>
                    :
                    <Button disabled={addFarmerMutation.isLoading || imageUploadMutation.isLoading} variant="primary" onClick={() => handleAddFarmer()}>
                        {(addFarmerMutation.isLoading || imageUploadMutation.isLoading) ? <Spinner animation="border" size="sm" /> : "Add"}
                    </Button>
                }
                <Button variant="secondary" onClick={() => props?.close()}>
                    Close
                </Button>
            </Modal.Footer>

            {showMap && <MapModal show={showMap} onHide={() => setShowMap(false)} zoom={18} handleLocation={handleLocationSelecion} />}
        </Modal>
    )
}
